import { Button, Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
// import { CompanyAdditionalInfoForm, CompanyInfoForm, CompanyInfoSection, CompanySubmitForm } from '../components/forms/company';
import {
    updateConsumer,
    getConsumer,
    changeStatusConsumer,
    removeAdminRoles,
    deleteConsumer,
} from '../app/slices/consumersSlice';
import { ScreenHeader } from '../components/screenHeader';
import {connect, useDispatch} from 'react-redux';
import {
    UserInfoForm,
} from '../components/forms/user';
import { withRouter } from '../wrappers/withRouter';
import { DeleteOutline } from '@mui/icons-material';
import { showModal } from '../app/slices/modalSlice';
import {apiClient} from "../providers/apiClient";
import { APP_URLS } from '../app/config';

const UserEditScreen = (props) => {
    const {
        getConsumer,
        params,
        updateConsumer,
        changeStatusConsumer,
        deleteConsumer,
        removeAdminRoles,
        navigate,
        model,
        isAdmin,
        showModal,
        t_modals,
        location,
    } = props;
    
    const dispatch = useDispatch();

    const refresh = useCallback(async () => {
        await getConsumer(params.id);
    }, [getConsumer, params.id]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const handleFieldSave = async (field, value) => {
        await updateConsumer({
            id: params.id,
            fieldName: field,
            value: value,
        });

        await refresh();
    };

    const handleSendSetPassword = () => {
        apiClient.get(APP_URLS.USER_SEND_SET_NEW_PASSWORD.replace('{id}', params.id))
            .then((result) => {
                if (result.status === 200) {
                    showModal({ message: t_modals('LinkSendSuccess')});
                } else {
                    showModal({ message: t_modals('LinkSendError')});
                }
            })
    };

    const handleStatusChange = () => {
        changeStatusConsumer(model.id).then(() => refresh());
    };

    const handleDelete = useCallback(async (user) => {
        console.log('[userEdit.screen] 🚀 ', user);
        const modalParams = {
            title: 'User account deletion',
            message: `Are you sure that you want to delete ${user.fullName}?`,
            button: 'Delete',
            mode: 'normal',
            cancelButton: true,
            fallback: async () => {
                try {
                    await apiClient.delete(`/api/Account?id=${user.id}`);
                    navigate(-1);
                } catch (e) {
                    console.error(e);
                }
            }
        };

        dispatch(showModal(modalParams));
    }, [refresh, showModal]);

    const handleRemoveRole = () => {
        removeAdminRoles(model.id).then(() => navigate(-1));
    };

    const before = new URLSearchParams(location?.search).get('before');
    const beforeUrl = before ? decodeURIComponent(before) : null;

    return (
        <div className="fk-screen">
            <ScreenHeader
                withBackButton
                withSeparator
                title="userHeader"
                navigateBackRoute={"/users"}
                before={beforeUrl}
                titleReplacement={['#USER_NAME#', model.fullName]}
                subtitle="userSubheader"
                subtitleReplacement={['#USER_ID#', model.friendlyId]}
                additionalButtons={
                    <div className="screen-header-buttons --flex-end">
                        <Button className="green" onClick={handleSendSetPassword}>Resend activation link</Button>
                        {isAdmin &&
                        <Button className="red" onClick={() => handleDelete(model)}><DeleteOutline /> Delete</Button>
                        }
                    </div>
                }
            />
            <Grid container spacing={4}>
                <Grid item md={6}>
                    <UserInfoForm canEdit onUpdate={handleFieldSave} isAdmin={isAdmin} />
                </Grid>
            </Grid>
        </div>
    );
};

const mapStateToProps = (state) => ({
    model: state.consumers.consumer,
});

const actions = {
    updateConsumer,
    getConsumer,
    changeStatusConsumer,
    deleteConsumer,
    removeAdminRoles,
    showModal,
};

export default withRouter(connect(mapStateToProps, actions)(UserEditScreen));
